require('./bootstrap-vue')
require('./axios')
require('./sweetalert2')